import * as Colors from '../constants/criticalityColors'

/**
 * Returns the color for the criticality type, based on the theme, or the default color if the type is not found.
 *
 */
export const getCriticalColor = (type: string, theme: Theme): string => {
    const upper = type?.toUpperCase()

    const typeColor = Colors.CriticalityColor[upper]

    if (!typeColor) return Colors.CriticalityColor.NONE.light

    return typeColor[theme] || typeColor.light
}

export const getCriticalBgColor = (type: string, theme: Theme): string => {
    const upper = type?.toUpperCase()

    const typeColor = Colors.CriticalityBgColor[upper]

    if (!typeColor) return Colors.CriticalityBgColor.NONE.light

    return typeColor[theme] || typeColor.light
}

export const getCriticalChartColor = (type: string, theme: Theme): string => {
    const upper = type?.toUpperCase()

    const typeColor = Colors.CriticalityChartColor[upper]

    if (!typeColor) return Colors.CriticalityChartColor.NONE.light

    return typeColor[theme] || typeColor.light
}

export const getCriticalBorderColor = (type: string, theme: Theme): string => {
    const upper = type?.toUpperCase()

    const typeColor = Colors.CriticalityBorderColor[upper]

    if (!typeColor) return Colors.CriticalityBorderColor.NONE.light

    return typeColor[theme] || typeColor.light
}

export const getCriticalBgBlinkColor = (type: string, theme: Theme): string => {
    const upper = type?.toUpperCase()

    const typeColor = Colors.CriticalityBgBlinkColor[upper]

    if (!typeColor) return Colors.CriticalityBgBlinkColor.NONE.light

    return typeColor[theme] || typeColor.light
}

export const getCriticalWidgetBorderColor = (type: string, theme: Theme): string => {
    const upper = type?.toUpperCase()

    const typeColor = Colors.CriticalityWidgetBorderColor[upper]

    if (!typeColor) return Colors.CriticalityWidgetBorderColor.NONE.light

    return typeColor[theme] || typeColor.light
}
